import { default as WJElement } from '../wje-element/element.js';
import Carousel from './carousel.element.js';

// export * from "./carousel.element.js";
export default Carousel;

WJElement.define('wje-carousel', Carousel);
